import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import AdvancedFacetMixin from '../mixins/advanced_facet_mixin'
import createReactClass from 'create-react-class'
export default createReactClass({
  mixins: [AdvancedFacetMixin],

  getInitialState() {
    return {autocomplete: null};
  },

  getDefaultProps() {
    return {
      form: null,
      map: null,
      filters: [],
      options: {},
      general_inputs:
        ['table_d_hotes', 'family_room', 'is_large_groups', 'wheelchair_accessible', 'non_smoking', 'adults_only'],
      location_inputs:
        ['on_camping', 'on_vineyard', 'on_farm', 'near_country_side', 'near_village', 'near_city', 'near_hills',
          'near_mountains', 'near_public_transport'],
      facility_inputs:
        ['has_tennis_at_object', 'has_pool_inside', 'has_heated_pool', 'has_bike_at_object', 'has_boat_at_object', 'has_child_bed',
         'has_child_chair', 'is_children_safe', 'has_babysitter', 'has_playing_room_outside', 'has_tv',
         'has_sauna', 'has_jacuzzi', 'has_course_room', 'has_washing_machine', 'has_vegetable_garden', 'has_fenced_garden', 'has_airco'],
      activity_inputs:
        ['near_themepark', 'has_activities_program', 'near_bike', 'near_mountainbike', 'near_hiking', 'near_horseriding',
          'near_watersports', 'near_fishsport', 'near_mountainsports', 'near_flying', 'has_painting_course', 'has_pottery',
          'has_yoga', 'has_cooking_course', 'has_language_course', 'has_other_courses']
    };
  },

  render() {
    const self = this;

    const general_inputs = ['allows_pets'].map(filter => self.createInput(filter));
    const bed_room_options = [1, 2, 3, 4, 5].map(i => {
      return { value: i, label: I18n.t('search.attributes.bedrooms', {count: i}) }
    });

    const bed_rooms_placeholder = I18n.t('search.placeholders.bedrooms');
    general_inputs.push(self.createSelect2Input('bedrooms', bed_room_options, false, bed_rooms_placeholder, 'input--yellow input--small'));
    const general_sub_inputs = this.props.general_inputs.map(filter => self.createInput(filter));

    const location_inputs = ['near_beach', 'near_water'].map(filter => self.createInput(filter));
    const location_sub_inputs = this.props.location_inputs.map(filter => self.createInput(filter));

    const facility_inputs = ['has_swimmingpool', 'has_internet'].map(filter => self.createInput(filter));
    const facility_sub_inputs = this.props.facility_inputs.map(filter => self.createInput(filter));

    const activity_inputs = ['near_skiing', 'has_golfcourse'].map(filter => self.createInput(filter));
    const activity_sub_inputs = this.props.activity_inputs.map(filter => self.createInput(filter));

    const general    = this.createSubForm(I18n.t('search.form_labels.general'), general_inputs, general_sub_inputs, 'general');
    const location   = this.createSubForm(I18n.t('search.form_labels.location'), location_inputs, location_sub_inputs, 'location');
    const facilities = this.createSubForm(I18n.t('search.form_labels.facilities'), facility_inputs, facility_sub_inputs, 'facilities');
    const activities = this.createSubForm(I18n.t('search.form_labels.activities'), activity_inputs, activity_sub_inputs, 'activities');
    const areas      = this.generateAreaInputs();

    return <div>
      {general}
      {location}
      {facilities}
      {activities}
      {areas}
    </div>;
  }
});
